import { getToken, getUser } from "../../Utilities/Common";
import { getWithParamsAPICall, postAPICallwithFile } from "../axiosMethodCall";

export const getMedicalCertificate = async (data) => {
  try {
    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "forms/medical_certificate",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: data.patient_id,
      }
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const getMedicalAbstract = async (data) => {
  try {
    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "forms/medical_abstract",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: data.patient_id,
      }
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const getMedicalSummary = async (data) => {
  try {
    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "forms/medical_summary",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: data.patient_id,
      }
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const saveForm = async (data) => {
  try {
    var formData = new FormData();
    formData.append("requester", getUser());
    formData.append("token", getToken());
    formData.append("patient_id", data.patient_id);
    formData.append("form_template_id", data.form_template_id);

    // Medical Abstract (id: 6)
    if (data.form_template_id === 6) {
      formData.append("plan", data.plan);

      data.diagnosis.forEach((d) => formData.append("diagnosis[]", d));

      data.therapeutics.forEach((t) => {
        var parsed = JSON.parse(t);
        formData.append("therapeutic_id[]", parsed.therapeutic_id);
        formData.append("therapeutic_name[]", parsed.therapeutic_name);
      });
    }
    // Medical Certificate (id: 1-4) and Referral Letter (id: 5)
    else {
      formData.append("content", data.content);
    }

    const response = await postAPICallwithFile(
      process.env.REACT_APP_LINK + "forms/save",
      formData
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};
